import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import clsx from "clsx";
import { Col, Container, Row } from "react-bootstrap";
import { TREE_STATUS } from "@constants";
import styles from "./style/CoursesContentTab.module.css";
import { SectionContentTree } from "@components/LectureContentTree/SectionContentTree";
import { formatNumberText } from "@helpers";

const CoursesContentTab = (props) => {
  const { sectionList } = props;
  const [treeStatus, setTreeStatus] = useState(TREE_STATUS.COLLAPSE_ALL);
  const [lessons, setLessons] = useState();
  const [numRemainLecture, setNumRemainLecture] = useState(0);

  useEffect(() => {
    setLessons(sectionList);
  }, [sectionList]);

  const handleChangeTreeStatus = () => {
    if (treeStatus !== TREE_STATUS.COLLAPSE_ALL) {
      setTreeStatus(TREE_STATUS.COLLAPSE_ALL);
    } else {
      setTreeStatus(TREE_STATUS.EXPAND_ALL);
    }
  };

  const handleSeeMore = () => {
    setNumRemainLecture(0);
  };

  const totalLessons =
    sectionList?.reduce((total, val) => {
      return total + val.lessons.length;
    }, 0) || 0;

  return (
    <Container fluid className="p-0 py-5">
      <Row className="mb-4">
        <Col>
          <h5>Course content</h5>
        </Col>
        <Col className={styles.lectureInfoContainer}>
          <button onClick={handleChangeTreeStatus}>
            {treeStatus === TREE_STATUS.EXPAND_ALL
              ? "Collapse all"
              : "Expand all"}
          </button>
          <span>{formatNumberText(totalLessons, "lesson")}</span>
        </Col>
      </Row>
      <div>
        <SectionContentTree
          sectionList={lessons || []}
          treeStatus={treeStatus}
        />
        {numRemainLecture !== 0 && (
          <button
            className={clsx(styles.btnSeeMore, "p-2")}
            onClick={handleSeeMore}
          >
            {numRemainLecture} More Sections
          </button>
        )}
      </div>
    </Container>
  );
};

/* required: display name */
CoursesContentTab.displayName = "CoursesContentTab";

/* required: props types */
CoursesContentTab.propTypes = {
  totalLessons: PropTypes.number,
  totalTime: PropTypes.number,
  sectionList: PropTypes.array,
};

/* required: default props */
CoursesContentTab.defaultProps = {
  totalLessons: 0,
  totalTime: 0,
  sectionList: [],
};

export { CoursesContentTab };
